import * as React from 'react';
import Styled from 'styled-components';

import { media } from '../../lib/StyledComponents';
import { LabelStyles } from '../Typography/Label';

export interface IVTableCellProps extends React.HTMLAttributes<HTMLTableCellElement> {
  /**
   * A description to show when the table has been collapsed for a small screen
   */
  collapsedDescription: string;
}

const TableDataCell = Styled.td`
  display: block;
  text-align: left;
  padding-bottom: 1.5em;
  font-size: 1.4rem;

  &:first-child {
    padding-top: 1.5em;
  }

  &:last-child {
    padding-bottom: 2em;
  }

  &::before {
    ${LabelStyles}
    text-transform: ${({ theme: { label } }) => label.textTransform};
    content: attr(data-th);
    display: block;
    padding-bottom: 0.25em;
  }

  ${media.small`
    display: table-cell;
    padding: 0.25em 0.5em;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }

    &::before {
      /* label visible only on mobile breakpoint */
      display: none;
    }
  `}
`;

export class VTableCell extends React.PureComponent<IVTableCellProps> {
  public render () {
    const { collapsedDescription, ...restProps } = this.props;

    return (
      <TableDataCell data-th={collapsedDescription} {...restProps} />
    );
  }
}

export const VTableHeaderCell = Styled.th`
  ${LabelStyles}
  text-transform: ${({ theme: { label } }) => label.textTransform};

  /* hidden on mobile breakpoint */
  display: none;

  ${media.small`
    display: table-cell;
    padding: 0.25em 0.5em;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }
  `}
`;

export const VTableRow = Styled.tr`
  border-bottom: 1px solid ${({ theme: { table } }) => table.colorDivider };

  &:first-child {
    border: none;
  }

  &:last-child {
    border: none;
  }
`;
